import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule, Routes } from '@angular/router';
import { JcfManager } from './globals/jcf-manager';
import { GlobalService } from './services/global/global.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { PingInterceptor } from './interceptors/ping-interceptor';
import { PingService } from './services/ping/ping.service';
import {CookieService} from "ngx-cookie-service";
import {ContentModule} from "./components/content/content.module";
import {ErrorTokenComponent} from "./components/error-token/error-token.component";
import {GoogleAnalyticsService} from "google-analytics";
import {NgbModalModule} from "@ng-bootstrap/ng-bootstrap";
import {McpBeaconService} from "mcp-beacon";
import {AuthInterceptor} from './api/interceptors/auth.interceptor';

const routes: Routes = [
  { path: '', redirectTo: 'landing', pathMatch: 'full' },
  { path: 'lead-form', loadChildren: './components/lead-form/lead-form.module#LeadFormModule' },
  { path: 'otp-capture-form', loadChildren: './components/otp-capture-form/otp-capture-form.module#OtpCaptureFormModule' },
  { path: 'vitality-premium-form', loadChildren: './components/vitality-premium-form/vitality-premium-form.module#VitalityPremiumFormModule' },
  { path: 'display-account-info', loadChildren: './components/display-account-info/display-account-info.module#DisplayAccountInfoModule' },
  { path: 'agent-broker', loadChildren: './components/agent-broker/agent-broker.module#AgentBrokerModule' },
  { path: 'premiums-and-contributions', loadChildren: './components/premiums-and-contributions/premiums-and-contributions.module#PremiumsAndContributionsModule' },
  { path: 'activation-terms-and-conditions', loadChildren: './components/activation-terms-and-conditions/activation-terms-and-conditions.module#ActivationTermsAndConditionsModule' },
  { path: 'activation-result', loadChildren: './components/activation-result/activation-result.module#ActivationResultModule' },
  { path: 'join-vitality', loadChildren: './components/join-vitality/join-vitality.module#JoinVitalityModule' },
  { path: 'debit-order-mandate', loadChildren: './components/debit-order-mandate/debit-order-mandate.module#DebitOrderMandateModule'},
];

@NgModule({
  declarations: [
    AppComponent,
    ErrorTokenComponent,
  ],
  imports: [
    ContentModule,
    AppRoutingModule,
    RouterModule.forRoot(routes, {useHash: true}),
    BrowserAnimationsModule,
    BrowserModule,
    FormsModule,
    HttpClientModule,
    NgbModalModule
  ],
  providers: [
    GoogleAnalyticsService,
    GlobalService,
    PingService,
    JcfManager,
    CookieService,
    McpBeaconService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PingInterceptor,
      multi: true
    },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
  ],
  exports: [
    BrowserModule,
    BrowserAnimationsModule,
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }
